import React from "react";
import { motion } from "framer-motion";
import {
  FaCheckCircle,
  FaBriefcase,
  FaLaptopCode,
  FaUserTie,
} from "react-icons/fa";
import { jobs } from "./data";

const Experience = () => {
  // Map different job types to icons
  const getJobIcon = (title, company) => {
    if (title.includes("Tech Lead")) return <FaUserTie />;
    if (title.includes("Senior")) return <FaLaptopCode />;
    if (company === "Freelance") return <FaBriefcase />;
    return <FaLaptopCode />;
  };

  return (
    <motion.div
      exit={{ opacity: 0 }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <section className="section education-section">
        <div className="section-title">
          <h2>Professional Experience</h2>
          <div className="underline"></div>
        </div>

        <div className="education-timeline">
          {jobs.map((item, index) => (
            <motion.article
              key={item.id}
              className="education-item"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className="education-icon-wrapper">
                <div className="education-icon">
                  {getJobIcon(item.title, item.company)}
                </div>
              </div>

              <div className="education-content">
                <div className="education-header">
                  <h3>{item.title}</h3>
                  <span className="education-year">{item.dates}</span>
                </div>

                <h4 className="education-institution">
                  {item.company} • {item.location}
                </h4>

                <div className="experience-duties-list">
                  {item.duties.map((duty, idx) => (
                    <div key={idx} className="duty-item">
                      <FaCheckCircle className="duty-check-icon" />
                      <p>{duty}</p>
                    </div>
                  ))}
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </section>
    </motion.div>
  );
};

export default Experience;
